import { LandingBrandPlacementListingTypeEnum } from '../../graphql/types';

export const PROJECTS_GRID_FILTERS = [
  { labelKey: 'pasha.filter_all', value: 'ALL' },
  {
    labelKey: 'pasha.filter_rent',
    value: LandingBrandPlacementListingTypeEnum.Rent
  },
  {
    labelKey: 'pasha.filter_sale',
    value: LandingBrandPlacementListingTypeEnum.Sale
  }
] as const;

export const makeDataStat = (input: string) =>
  input
    .toLowerCase()
    .replace(/[^a-z0-9]+/gi, ' ')
    .trim()
    .replace(/\s+/g, '-');

export const AUTOPLAY_INTERVAL = 10000;
